import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

/**
 * Returns a function that revalidates every cached policy list and policy, for writes made outside the
 * hooks that loaded them. It resolves once they have reloaded.
 */
export function useInvalidatePolicies() {
  const { mutate: globalSwrMutate } = useSWRConfig();

  return useCallback(
    () =>
      globalSwrMutate(
        (key: unknown) =>
          typeof key === 'string' &&
          (key.startsWith('transfer-pricing/policy?') ||
            key.startsWith('transfer-pricing/policy/'))
      ),
    [globalSwrMutate]
  );
}
